import React from "react";
import "./About.css"

export default function About() {
   return (
      <div className="about-container">
         <span>
            Introducing "Bohra Connect" - Bridging Communities Worldwide Welcome
            to the world of "Bohra Connect," the innovative app designed to
            revolutionize the way Bohra community members connect and
            collaborate across borders. Moving to a new country comes with its
            set of challenges, and one of the most significant is finding
            like-minded individuals from our community. While traditional social
            media platforms offer search features based on names, locations, and
            even professions, they often fall short when it comes to identifying
            fellow Bohra community members. This is where "Bohra Connect" steps
            in – to bridge the gap and foster connections within our global
            community.
         </span>
         <h4>Our Motivation: Fostering Unity in a Global Landscape</h4>
         <span>
            At "Bohra Connect," we understand the importance of staying
            connected to our roots while adapting to new environments. Our
            motivation stems from the realization that locating Bohra community
            members in a new country can be a daunting task. We believe that
            shared traditions, values, and experiences should transcend
            geographical boundaries, and technology can play a pivotal role in
            achieving this vision.
         </span>

         <h4>Empowering Connections Through Technology</h4>
         <span>
            "Bohra Connect" is not just an app; it's a platform that empowers
            individuals to establish meaningful connections with fellow Bohra
            community members around the world. Our app is built on the premise
            that every member of the community deserves an accessible and
            efficient means of finding and connecting with others who share the
            same background.
         </span>

         <h4>How It Works: Mapping Connections, One Pin at a Time</h4>

         <span>
            Our app operates on a simple yet ingenious concept. Users are
            invited to create profiles by providing their "Ejammaat ID," name,
            and location details. These profiles are then visualized on a global
            map, where each member's location is marked with a pin or marker.
            This map becomes a living representation of our vibrant community
            spread across the world.
         </span>
         <h4>Exploration with Purpose: Navigating the Community Map</h4>
         <span>
            Navigating the "Bohra Connect" map is an exciting journey of
            exploration. Users can zoom in to discover fellow community members
            near them, regardless of geographical distances. Each pin represents
            a person's unique story, a testament to the diversity and unity that
            define our community.
         </span>
         <h4>Connecting Beyond Borders: Social Links for Lasting Bonds</h4>

         <span>
            "Bohra Connect" goes beyond just locating individuals – it's about
            creating lasting connections. Each profile on the map includes
            social media links that allow users to reach out and connect with
            others directly. Whether you're seeking friendship, professional
            collaboration, or simply a familiar face in a new place, "Bohra
            Connect" enables these interactions with ease.
         </span>
         <h4>Join the Bohra Connect Movement</h4>

         <span>
            Bohra Connect" isn't just a tool; it's a movement to strengthen the
            Bohra community's bonds across the globe. We invite you to be a part
            of this exciting journey, to join hands in fostering unity, and to
            celebrate the shared values that make our community extraordinary.
            In a world where technology often divides, "Bohra Connect" unites –
            one pin, one connection, and one community at a time. Welcome to a
            new era of Bohra connectivity.
         </span>
      </div>
   );
}
